import {ICheatPluginController, ICheatsModule} from '../../CheatModuleInterfaces';
import {CommandLineInterface, consoleLogger, CoreDI, lazyInject} from '@gongxigames/framework/core';
import {GameConfig} from '@gongxigames/framework/slot/types';
import {AbstractFilter} from '@gongxigames/framework/slot/services/logic';
import {CheatFiltersController} from '../filters/CheatFiltersController';

type FiltersByGroup = Record<string, AbstractFilter[]>;

export class CheatDemoController implements ICheatPluginController {
    public static filtersByGroup: FiltersByGroup = {};
    protected filters: AbstractFilter[] = [];
    protected module!: ICheatsModule;

    @lazyInject(CoreDI.GameConfig)
    protected readonly gameConfig!: GameConfig;

    @lazyInject(CoreDI.CLI)
    private _cli!: CommandLineInterface;

    public static addFilters(filters: AbstractFilter[], groupName = ''): void {
        if (!this.filtersByGroup[groupName]) {
            this.filtersByGroup[groupName] = [];
        }

        this.filtersByGroup[groupName].push(...filters);
    }

    public onChanged: Function = (): void => {};

    public init(module: ICheatsModule): void {
        this.module = module;
        this.module.storage.on('cheatActions', () => this.onChanged(), this);

        const winFilters: any[] = CheatFiltersController.filtersByGroup['Win Type Filters'];

        CheatDemoController.addFilters(winFilters, 'Win Type Filters');

        this.filters = [];

        Object.values(CheatDemoController.filtersByGroup).forEach(filters => {
            this.filters.push(...filters);
        });

        this._cli.addCommand('selectFilter', this.selectFilter.bind(this));
        this._cli.addCommand('removeFilters', this.removeFilters.bind(this));
        this._cli.addCommand('getFilters', () => {
            this.filters.forEach(({name}) => consoleLogger.log(name));
        });
    }

    public get filtersByGroup(): FiltersByGroup {
        return CheatDemoController.filtersByGroup;
    }

    public get selectedFilters(): string[] {
        const {cheatActions} = this.module.storage.data;

        return this.filters
            .filter(filter => cheatActions.find( act => act.id === filter.name))
            .map(({name}) => name);
    }

    public toggleFilter(filterName: string): void {
        const filter = this.filters.find(filter => filter.name === filterName);

        if (filter) {
            const action = {
                id: filter.name,
                apply: () => this.module.addArrayFilter(filter),
                reject: () => this.module.removeArrayFilter(filter)
            };

            if (this.module.storage.data.cheatActions.find(a => a.id === action.id)) {
                this.module.removeCheatAction(action);
            } else {
                this.module.addCheatAction(action);
            }
        }
    }

    protected removeFilters(): void {
        this.selectedFilters.forEach(this.toggleFilter.bind(this));
    }

    protected selectFilter(filterName: string): void {
        const filter = this.filters.find(filter => filter.name === filterName);

        if (filter) {
            const action = {
                id: filter.name,
                apply: () => this.module.addArrayFilter(filter),
                reject: () => this.module.removeArrayFilter(filter)
            };

            if (!this.module.storage.data.cheatActions.find(a => a.id === action.id)) {
                this.module.addCheatAction(action);
            }
        }
    }
}
